import React from 'react'
import logo from '../assets/logo-black.png'

const Hero = () => {
  
    return (
      <section id="hero" className='relative overflow-hidden bg-hero bg-center bg-no-repeat bg-cover min-h-screen flex items-center'>
        {/* Overlay gradient moderne */}
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/50 to-transparent"></div>
        
        <div className="container mx-auto flex px-5 py-24 items-center justify-center flex-col relative z-10">
          {/* Logo avec effet moderne */}
          <div className="relative mb-12">
            <div className="absolute -inset-4 bg-gradient-to-r from-primary to-red-600 rounded-full blur-xl opacity-30 animate-pulse"></div>
            <img className="relative lg:w-80 md:w-64 w-56 object-cover object-center rounded-2xl shadow-2xl bg-white p-4 transform hover:scale-105 transition-transform duration-300" alt="ECKSD Logo" src={logo} />
          </div>
          
          <div className="text-center lg:w-4/5 w-full space-y-8">
            {/* Titre principal avec style moderne */}
            <h1 className="title-font text-5xl md:text-6xl lg:text-7xl mb-6 font-bold text-white leading-tight">
              <span className="block text-3xl md:text-4xl lg:text-5xl font-medium text-gray-200 mb-2">École Ceyratoise de</span>
              <span className="bg-gradient-to-r from-primary to-red-500 bg-clip-text text-transparent">Karaté</span>
              <span className="text-white"> & </span>
              <span className="bg-gradient-to-r from-red-500 to-primary bg-clip-text text-transparent">Self Défense</span>
            </h1>
            
            {/* Sous-titre sportif */}
            <p className="text-xl md:text-2xl text-gray-200 font-light max-w-4xl mx-auto leading-relaxed">
              Apprenez les arts martiaux dans un environnement moderne et bienveillant. 
              <span className="block mt-2 font-semibold text-white">Karaté • Self-Défense</span>
            </p>
            
            {/* Boutons d'action modernes */}
            <div className="flex flex-col sm:flex-row justify-center gap-4 mt-10">
              <a href='#cours' className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-gradient-to-r from-primary to-red-600 rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 overflow-hidden">
                <span className="absolute inset-0 bg-gradient-to-r from-red-600 to-primary opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                <span className="relative flex items-center space-x-2">
                  <span>Rejoins-nous</span>
                  <svg className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
                  </svg>
                </span>
              </a>
              
              <a href='#contact' className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white border-2 border-white/30 rounded-full hover:bg-white/10 hover:border-white/50 transition-all duration-300 backdrop-blur-sm">
                <span className="flex items-center space-x-2">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                  </svg>
                  <span>Contact</span>
                </span>
              </a>
            </div>
            
            {/* Stats ou informations rapides - Masqué sur mobile */}
            <div className="hidden md:grid md:grid-cols-3 gap-6 mt-16 max-w-4xl mx-auto">
              <div className="text-center p-6 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/20">
                <div className="text-3xl font-bold text-primary mb-2">2+</div>
                <div className="text-white font-medium">Disciplines</div>
              </div>
              <div className="text-center p-6 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/20">
                <div className="text-3xl font-bold text-primary mb-2">4</div>
                <div className="text-white font-medium">Instructeurs</div>
              </div>
              <div className="text-center p-6 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/20">
                <div className="text-3xl font-bold text-primary mb-2">4</div>
                <div className="text-white font-medium">Cours disponibles</div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Scroll indicator - Masqué sur mobile */}
        <div className="hidden md:block absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <svg className="w-6 h-6 text-white/70" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
          </svg>
        </div>
      </section>
    
  )
}

export default Hero